import ReturnIframeDataTransformerBlock, {
    ReturnIframeDataTransformerBlockProps,
} from '@activebrands/core-web/libs/storyblok/content/CmsDataTransformerBlock/ReturnIframeDataTransformerBlock';
import { styled } from '@activebrands/core-web/libs/styletron';
import { BaseModuleProps } from '@activebrands/core-web/types/modules';
import { StyletronStyle } from '@activebrands/core-web/types/styletron';
import { getSafariCompatibleStyles } from '@activebrands/core-web/utils/get-safari-compatible-styles';
import getModuleBottomMarginStyles from '@activebrands/core-web/utils/style-functions/get-module-bottom-margin-styles';

const HeroWrapper = styled('section', ({ $isGrid }) => ({
    width: '100%',
    ...getModuleBottomMarginStyles($isGrid),
}));

const ContentWrapper = styled('section', ({ $isGrid }) =>
    getSafariCompatibleStyles({
        aspectRatio: 'var(--ratio-module-flexible)',
        width: '100%',
        minHeight: '580px',
        height: '100%',
        ...getModuleBottomMarginStyles($isGrid),
        position: 'relative',
    })
);

interface ReturnIframeModuleProps extends BaseModuleProps, ReturnIframeDataTransformerBlockProps {
    $heroStyling?: StyletronStyle;
    isHero?: boolean;
}

const ReturnIframeModule = ({
    $heroStyling = { height: '100vh' },
    isGrid = false,
    isHero = false,
    ...rest
}: ReturnIframeModuleProps) => {
    if (isHero) {
        return (
            <HeroWrapper $style={$heroStyling} $isGrid={isGrid}>
                <ReturnIframeDataTransformerBlock {...rest} />
            </HeroWrapper>
        );
    }

    return (
        <ContentWrapper $isGrid={isGrid}>
            <ReturnIframeDataTransformerBlock {...rest} />
        </ContentWrapper>
    );
};

export default ReturnIframeModule;
